import React from 'react';
import { mockData } from '../mockData';
import { Button } from './ui/button';
import { Check, Star } from 'lucide-react';
import { useToast } from '../hooks/use-toast';

const PricingSection = ({ onOpenModal }) => {
  const handleGetTrademark = (planName) => {
    if (onOpenModal) {
      onOpenModal();
    }
  };

  return (
    <section id="pricing" className="py-20 bg-gradient-to-br from-emerald-50 via-teal-50 to-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">
            Cost-Effective{' '}
            <span className="bg-brand-gradient bg-clip-text text-transparent">
              Trademark Solutions
            </span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            At Trademark Law Associates, we provide affordable trademark registration services designed to suit businesses of all sizes.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {mockData.pricingPlans.map((plan) => (
            <div
              key={plan.id}
              className={`relative rounded-2xl p-8 transition-all duration-300 hover:scale-105 flex flex-col h-full ${
                plan.popular
                  ? 'bg-gradient-to-br from-emerald-600 to-teal-500 text-white shadow-2xl ring-4 ring-emerald-200'
                  : 'bg-white shadow-lg hover:shadow-xl border border-emerald-100'
              }`}
            >
              {plan.popular && (
                <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
                  <div className="bg-yellow-400 text-gray-800 px-4 py-1 rounded-full text-sm font-bold flex items-center space-x-1">
                    <Star size={16} fill="currentColor" />
                    <span>POPULAR</span>
                  </div>
                </div>
              )}

              <div className="text-center mb-6">
                <h3
                  className={`text-2xl font-bold mb-2 ${
                    plan.popular ? 'text-white' : 'text-gray-800'
                  }`}
                >
                  {plan.name}
                </h3>
                <div className="flex items-baseline justify-center">
                  <span
                    className={`text-5xl font-bold ${
                      plan.popular ? 'text-white' : 'text-brand-primary'
                    }`}
                  >
                    ${plan.price}
                  </span>
                </div>
                <p
                  className={`text-sm mt-2 ${
                    plan.popular ? 'text-emerald-50' : 'text-gray-500'
                  }`}
                >
                  *(Govt. filing fee not included)
                </p>
              </div>

              <div className="flex-grow mb-6 overflow-y-auto max-h-64 pr-2 scrollbar-thin scrollbar-thumb-emerald-300 scrollbar-track-transparent">
                <div className="space-y-3">
                  {plan.features.map((feature, idx) => (
                    <div key={idx} className="flex items-start space-x-2">
                      <Check
                        className={`flex-shrink-0 mt-0.5 ${
                          plan.popular ? 'text-emerald-100' : 'text-brand-primary'
                        }`}
                        size={20}
                      />
                      <span
                        className={`text-sm ${
                          plan.popular ? 'text-white' : 'text-gray-600'
                        }`}
                      >
                        {feature}
                      </span>
                    </div>
                  ))}
                </div>
              </div>

              <Button
                onClick={() => handleGetTrademark(plan.name)}
                className={`w-full mt-auto ${
                  plan.popular
                    ? 'bg-white text-brand-primary hover:bg-gray-50 border-2 border-brand-primary'
                    : 'bg-brand-gradient text-white hover:opacity-90'
                }`}
              >
                Get a Trademark
              </Button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PricingSection;
